import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Message, translator } from 'mage-i18n';
import { Row, Column } from 'mage-components';
import {
  IllustrationSecurity,
  ButtonQuaternary,
  Typography,
  SpacerVertical,
} from '@klarna/bubble-ui';

import { ContainerTemplate, MessagingStep } from '@/components';

const tPrefix = 'products-fe.containers.user_already_exists';

const goToMerchantPortal = () => (document.location.href = '/');

const UserAlreadyExistsInner = ({ t }) => (
  <ContainerTemplate>
    <MessagingStep illustration={<IllustrationSecurity />} title={[t(`${tPrefix}.title`)]}>
      <Row>
        <Column>
          <SpacerVertical spaceToken="space/150" />
          <Typography textToken="text-style/text/super-paragraphs/tall/regular">
            <Message path={`${tPrefix}.message_1`} />
          </Typography>
          <SpacerVertical spaceToken="space/300" />
        </Column>
      </Row>
      <Row>
        <Column columns={{ mobile: 12, tablet: 8 }}>
          <ButtonQuaternary size="medium" onClick={goToMerchantPortal}>
            {t(`${tPrefix}.log_in`)}
          </ButtonQuaternary>
        </Column>
      </Row>
    </MessagingStep>
  </ContainerTemplate>
);

UserAlreadyExistsInner.propTypes = {
  t: PropTypes.func.isRequired,
};

export const UserAlreadyExists = compose(
  connect(state => ({
    t: translator(state),
  })),
)(UserAlreadyExistsInner);
